import {configure, makeObservable, observable, action} from 'mobx';
import {route} from "ziggy-js";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import reachGoalVkAds from "@/Helpers/ReachGoalVkAds";
import {dataLayerPush} from "@/Helpers/Function";

/**
 * Класс для работы с избранным
 */
export default class FavouritesStore {
    // Массив избранного
    @observable favouritesData = []
    @observable favouritesDataPage = []

    // Флаг загрузчика
    @observable favouritesLoader = false

    constructor(rootStore) {
        makeObservable(this)
        configure({
            enforceActions: "never",
        })
        this.rootStore = rootStore;
    }

    @action favouritesDataChange(favouritesData) {
        this.favouritesData = favouritesData;
    }

    /**
     * Обработка добавления / удаления избранного
     * @param e
     * @param product
     * @returns {Promise<void>}
     */
    @action async favouritesChange(e, product) {
        try {
            const checked = e.target.checked;
            let routeName = checked ? 'favourites.add' : 'favourites.delete';

            // Стучимся на сервак
            const response = await axios.post(route(routeName), {
                product_id: product.id
            });

            const {success = {}} = response.data;
            const {status = false, data = {}} = success;
            const {favourites = []} = data;

            if (status) {
                if (checked) {
                    // Отправка цели
                    reachGoalYM('add_wish');

                    // Отправка цели
                    reachGoalGA('add_wish');

                    dataLayerPush('add_to_wishlist', 'catalog', 'addToWishlist', 'product', '',
                        [{
                            ...product,
                            'product_id': product.id,
                            'count': 1,
                            'price': product.currentPrice,
                        }]
                    );

                    // Отправка цели VK
                    reachGoalVkAds('addToWishlist', product.currentPrice, product.id);
                }

                // Если статус положительный
                this.favouritesData = favourites;
            }
        } catch (e) {
            console.log('e', e);
        }
    }
}
